import { lazy, Suspense } from 'react'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import { ProtectedRoute } from './components/ProtectedRoute'
import Login from './pages/Login'
import AuthVerify from './pages/AuthVerify'

const Landing = lazy(() => import('./pages/Landing'))
const Setup = lazy(() => import('./pages/Setup'))
const Totem = lazy(() => import('./pages/Totem'))
const CheckinQR = lazy(() => import('./pages/CheckinQR'))
const Display = lazy(() => import('./pages/Display'))
const PatientStatus = lazy(() => import('./pages/PatientStatus'))
const Professional = lazy(() => import('./pages/Professional'))
const Admin = lazy(() => import('./pages/Admin'))

function PageLoader() {
  return (
    <div className="min-h-screen flex items-center justify-center" style={{ background: 'var(--background)' }}>
      <div
        className="w-10 h-10 rounded-full border-4 border-t-transparent animate-spin"
        style={{ borderColor: 'var(--border)', borderTopColor: 'var(--primary)' }}
      />
    </div>
  )
}

export function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route
          path="/"
          element={
            <Suspense fallback={<PageLoader />}>
              <Landing />
            </Suspense>
          }
        />
        <Route path="/login" element={<Login />} />
        <Route path="/auth/verify" element={<AuthVerify />} />
        <Route
          path="/setup"
          element={
            <ProtectedRoute>
              <Suspense fallback={<PageLoader />}>
                <Setup />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/totem"
          element={
            <Suspense fallback={<PageLoader />}>
              <Totem />
            </Suspense>
          }
        />
        <Route
          path="/checkin"
          element={
            <Suspense fallback={<PageLoader />}>
              <CheckinQR />
            </Suspense>
          }
        />
        <Route
          path="/display/:token"
          element={
            <Suspense fallback={<PageLoader />}>
              <Display />
            </Suspense>
          }
        />
        <Route
          path="/status/:checkinId"
          element={
            <Suspense fallback={<PageLoader />}>
              <PatientStatus />
            </Suspense>
          }
        />
        <Route
          path="/professional"
          element={
            <ProtectedRoute>
              <Suspense fallback={<PageLoader />}>
                <Professional />
              </Suspense>
            </ProtectedRoute>
          }
        />
        <Route
          path="/admin"
          element={
            <ProtectedRoute requireRole="admin">
              <Suspense fallback={<PageLoader />}>
                <Admin />
              </Suspense>
            </ProtectedRoute>
          }
        />
      </Routes>
    </BrowserRouter>
  )
}
